import React from "react";

import UIStore, { UI_EVENTS } from "../stores/UIStore";

/**
 * Hook that gets the width of the viewport using UIStore
 *
 * @returns the current window width
 */
export const useWindowWidth = (): number => {
    const [width, setWidth] = React.useState(UIStore.instance.windowWidth);

    React.useEffect(() => {
        const onResize = (): void => {
            setWidth(UIStore.instance.windowWidth);
        };
        UIStore.instance.on(UI_EVENTS.Resize, onResize);

        return () => {
            UIStore.instance.removeListener(UI_EVENTS.Resize, onResize);
        };
    }, []);

    return width;
};
